import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Link, Grid } from "@material-ui/core";
import { FormActionDrawer, Camera } from "../../../components";
import { useHeader } from "../../../contexts";
import { hasGetUserMedia } from "../../../utils";
import { useTranslation } from "react-i18next";

const ScheduleInsuranceCard = ({
  scheduleData,
  updateScheduleData,
  setDrawerClearance,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();
  const [photo, setPhoto] = useState();

  useEffect(() => {
    setTitle(t("schedule.insurance_card.title"));
  }, []);

  /**
   * Skip step if no camera availability
   */
  useEffect(() => {
    if (!hasGetUserMedia()) updateScheduleData({ insurancePhoto: "" });
  }, [scheduleData]);

  /**
   * Set previously taken photo
   */
  useEffect(() => {
    if (scheduleData.insurancePhoto) {
      setPhoto(scheduleData.insurancePhoto);
    }
  }, [scheduleData]);

  /**
   * Handle take photo
   * @param {string} dataUri
   */
  const handleTakePhoto = dataUri => {
    if (dataUri) {
      setPhoto(dataUri);
    }
  };

  /**
   * Handle re-take photo
   */
  const handleRetakePhoto = () => {
    setPhoto();
  };

  /**
   * Handle next button
   */
  const handleNext = () => {
    updateScheduleData({ insurancePhoto: photo || "" });
  };

  return (
    <Box data-cy="schedule-screen-insurance-card">
      {photo ? (
        <Box my={1} textAlign="center">
          <Grid container justify="center" alignItems="center">
            <Grid item>
              <Button onClick={e => handleRetakePhoto()}>
                {t("schedule.insurance_card.button_retake")}
              </Button>
            </Grid>
            <Grid item>
              <Box ml={1}>
                <Typography>or</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Button onClick={e => handleNext()}>
                {t("schedule.insurance_card.button_skip")}
              </Button>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box my={1} mb={2} textAlign="center">
          <Typography gutterBottom>
            {t("schedule.insurance_card.skip_disclaimer")}
          </Typography>
          <Typography gutterBottom>
            <Link
              href="#"
              data-cy="insurance-card-skip"
              onClick={e => handleNext()}
            >
              {t("schedule.insurance_card.button_skip")}
            </Link>
          </Typography>
        </Box>
      )}
      {hasGetUserMedia() && (
        <Box mb={2}>
          <Camera photo={photo} onTakePhoto={handleTakePhoto} />
        </Box>
      )}
      {photo && (
        <FormActionDrawer
          setDrawerClearance={setDrawerClearance}
          handleNext={e => handleNext()}
          loading={isSubmitting}
        />
      )}
    </Box>
  );
};

export { ScheduleInsuranceCard };
